module.exports = __webpack_public_path__ + "static/media/swimming.7795ea66.jpg";